import { createApp } from "vue/dist/vue.esm-bundler";
import App from "./App.vue";
import axios from "axios";
import store from "./store/index";
import router from "./router/router";
import CarbonVue3 from "@carbon/vue";
import ChartsVue from "@carbon/charts-vue";
import { useVuelidate } from "@vuelidate/core";
import { CHECK_AUTH } from "./store/actions.type";
import { BluepagesAPIService, APIService } from "./common/api.service";
import "mutationobserver-shim";
import "@carbon/charts-vue/styles.css";
import "./styles/_carbon.scss";

router.beforeEach(async (to, from, next) => {
  // if user just filled out a form and is going to preview, don't reload user data
  if (to.name !== "policy_approval") {
    await store.dispatch(CHECK_AUTH);
  }

  // direct to login page if user not authenticated
  if (
    to.name !== "Login" &&
    !store.state?.user?.isAuthenticated &&
    to.name !== "feedback" &&
    to.name !== "suggestions" &&
    to.name !== "bug"
  ) {
    next({ name: "Login" });
  } else if (to.name == "Login" && !store.state?.user?.isAuthenticated) {
    // If the user has been redirected away from a specific page because they haven't logged in, then store this path in session storage
    if (to.redirectedFrom)
      window.sessionStorage.setItem("REROUTE_PATH", to.redirectedFrom.fullPath);
    next();
  } else {
    // Check session storage to see if user initially intended to go elsewhere after logging in
    const reroute_path = window.sessionStorage.getItem("REROUTE_PATH");
    // If they did, remove the link from session storage and navigate the user to said page
    if (reroute_path) {
      window.sessionStorage.removeItem("REROUTE_PATH");
      const reroute_details = processPath(reroute_path);
      next({ path: reroute_details.path, query: reroute_details.query });
    }
    // If not, navigate to the home page
    else next();
  }
});

function processPath(input) {
  // This function breaks down a full reroute path into the main path and the query
  let path = input;
  let query = {};

  // If the full path contains a ?, it has a query inside
  if (input.includes("?")) {
    [path, query] = input.split("?");
    // Queries are stored as id=1 for example in the path
    // This splits the string so that the query can be stored as {id: 1}, making it compatible with the next() function
    const [key, value] = query.split("=");
    query = { [key]: value };
  }

  return { path, query };
}

const v3App = createApp(App);

v3App.use(useVuelidate).use(router).use(store).use(CarbonVue3).use(ChartsVue);

v3App.provide("$axios", axios);
v3App.config.productionTip = false;
/** @TODO add error handling for v3App components */
v3App.config.errorHandler = (error) => {
  console.log(error);
};

APIService.init();
BluepagesAPIService.init();

v3App.mount("#app");
